import { ProgressCheckpoint } from "@/components/ui/async-progress";

// NOTE: Backend checkpoint updates in /document-service/tasks.py must be kept in sync
// Factory functions to create checkpoints based on job characteristics
export function createProjectExtractionCheckpoints(documentCount: number = 1): ProgressCheckpoint[] {
  return [
    {
      id: 'extracting_text',
      label: 'Extracting Text',
      description: 'Reading and extracting text from project documents',
      estimatedSeconds: 3 + documentCount * 3
    },
    {
      id: 'llm_processing',
      label: 'AI Analysis',
      description: 'Analyzing contract content to extract project details',
      estimatedSeconds: 7 + documentCount * 6
    }
  ];
}

export function createClaimExtractionCheckpoints(documentCount: number = 1): ProgressCheckpoint[] {
  return [
    {
      id: 'extracting_text',
      label: 'Extracting Data',
      description: documentCount > 1 ? 'Reading and extracting text from claim documents' : 'Reading and extracting text from claim document',
      estimatedSeconds: documentCount * 1
    },
    {
      id: 'llm_processing',
      label: 'AI Analysis',
      description: documentCount > 1 ? 'Analyzing documents to extract claim amounts and details' : 'Analyzing document to extract claim amounts and details',
      estimatedSeconds: documentCount * 3
    }
  ];
}

export function createContractReviewCheckpoints(claimDocCount: number = 1, contractDocCount: number = 1): ProgressCheckpoint[] {
  
  return [
    {
      id: 'extracting_contracts',
      label: 'Extracting Contract Data',
      description: contractDocCount > 1 ? 'Extracting text from contract documents' : 'Extracting text from contract document',
      estimatedSeconds: 3 + (contractDocCount * 3)
    },
    {
      id: 'extracting_claims',
      label: 'Extracting Claim Data',
      description: claimDocCount > 1 ? 'Extracting text from claim documents' : 'Extracting text from claim document',
      estimatedSeconds: claimDocCount * 1
    },
    {
      id: 'llm_review',
      label: 'AI Review',
      description: contractDocCount > 1 ? 'Comparing contract documents against claim terms' : 'Comparing contract document against claim terms',
      estimatedSeconds: 25 + contractDocCount * 3 + claimDocCount * 1
    }
  ];
}

export function createQuantityReviewCheckpoints(documentCount: number = 1): ProgressCheckpoint[] {
  return [
    {
      id: 'extracting_quantities',
      label: 'Extracting Data',
      description: documentCount > 1 ? 'Identifying quantities and measurements in documents' : 'Identifying quantities and measurements in document',
      estimatedSeconds: documentCount * 1
    },
    {
      id: 'validating_quantities',
      label: 'AI Review',
      description: 'Reviewing claimed quantities against industry standards',
      estimatedSeconds: 33 + (documentCount * 1)
    }
  ];
}

export function createCalculationReviewCheckpoints(documentCount: number = 1): ProgressCheckpoint[] {
  return [
    {
      id: 'extracting_calculations',
      label: 'Extracting Calculations',
      description: 'Identifying mathematical calculations in documents',
      estimatedSeconds: 10 + (documentCount * 2)
    },
    {
      id: 'verifying_calculations',
      label: 'AI Verification',
      description: 'Verifying mathematical accuracy of calculations',
      estimatedSeconds: 18 + (documentCount * 4)
    }
  ];
}

// Helper function to get checkpoint factory by workflow type
export function getCheckpointFactory(workflowType: string) {
  switch (workflowType) {
    case 'project-extraction':
      return createProjectExtractionCheckpoints;
    case 'claim-extraction':
      return createClaimExtractionCheckpoints;
    case 'contract-review':
      return createContractReviewCheckpoints;
    case 'quantity-review':
      return createQuantityReviewCheckpoints;
    case 'calculation-review':
      return createCalculationReviewCheckpoints;
    default:
      return createProjectExtractionCheckpoints; // fallback
  }
}